import { styled } from 'styled-components';
import { flexMixin, textMixin } from '@styles/mixins';
import { colors } from '@styles';

export const WrapDropdown = styled.div`
    ${flexMixin('column', 'flex-start', 'flex-start')}
    width: 100%;
    background: ${colors.cleanWhite};
    padding: 15px;
    border-radius: 6px;
`;

export const WrapUserCard = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    width: 100%;
`;
export const WrapUserIcon = styled.div`
    width: 56px;
    height: 56px;
    & img {
        width: 100%;
        height: 100%;
    }
`;

export const WrapTitle = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const TitleCard = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 600,
    })};
    line-height: 18px;
    text-align: left;
`;
export const SubTitleCard = styled.div`
    ${textMixin({
        fontSize: '12px',
        fontWeight: 400,
    })};
    line-height: 16px;
    text-align: left;
`;

export const StyledButton = styled.div`
    width: 166px;
    height: 30px;
    border-radius: 5px;
    padding-top: 2px;
    text-align: center;
    margin-top: 8px;
    background: ${colors.primaryBg};

    & span {
        ${textMixin({
            fontSize: '12px',
            fontWeight: 400,
        })};
        line-height: 28px;
        text-align: center;
        color: ${colors.cleanWhite};
    }

    &:hover {
        background: #8c2e77;
    }
`;
